export enum OptinTabEnum {
  thumbnail = 'thumbnail',
  thankYou = 'thankYou',
  options = 'options',
}

export const optinTabLocoKeys: Record<OptinTabEnum, string> = {
  [OptinTabEnum.thumbnail]: 'dashboard.store.item.thumbnail',
  [OptinTabEnum.thankYou]: 'dashboard.store.item.thank_you_page',
  [OptinTabEnum.options]: 'dashboard.store.item.options.title',
}
